import Plyr from 'plyr';

export default {
    init() {
        const videoPlayer = document.querySelectorAll('[data-message-hero]');

        videoPlayer.forEach(video => {
            const player = new Plyr(video.querySelector('[data-plyr]'), {
                controls: ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'fullscreen'],
                autoplay: true
            });
        });
    }
};
